import { render, staticRenderFns } from "./AuditTrailList.vue?vue&type=template&id=394768e2&scoped=true"
import script from "./AuditTrailList.vue?vue&type=script&lang=js"
export * from "./AuditTrailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394768e2",
  null
  
)

export default component.exports